<template>
   <div class="card shadow-sm border-0">
      <div class="card-body p-3">
         <!-- Header & Quick Action -->
         <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3 pb-2 border-bottom">
            <div>
               <h5 class="m-0 font-weight-bold text-dark-blue">
                  <i class="fa-solid fa-clock-rotate-left me-2 text-cyan"></i>
                  Platform &amp; Extension Release Notes
               </h5>
               <p class="text-muted small mb-0 mt-1">
                  Centralized release notes and platform updates.
               </p>
            </div>
            <div>
               <a 
                  :href="embedUrl" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  class="btn btn-sm btn-outline-secondary rounded-pill px-3"
               >
                  <i class="fa-solid fa-arrow-up-right-from-square me-1"></i> Open in New Tab
               </a>
            </div>
         </div>

         <!-- Centralized Spark Changelog Embed -->
         <div class="iframe-container position-relative">
            <div v-if="isLoading" class="loading-overlay d-flex flex-column align-items-center justify-content-center">
               <div class="spinner-border text-cyan mb-2" role="status">
                  <span class="visually-hidden">Loading...</span>
               </div>
               <span class="text-muted small">Loading release notes...</span>
            </div>

            <iframe 
               :src="embedUrl" 
               width="100%" 
               height="720" 
               frameborder="0" 
               style="border: none; border-radius: 12px; width: 100%; min-height: 720px;"
               title="X-Surflog Platform Release Notes"
               @load="isLoading = false"
            ></iframe>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'Changelogs',
   data() {
      return {
         isLoading: true,
         embedUrl: process.env.VUE_APP_SPARK_CHANGELOG_URL || 'http://localhost:8004/api/public/changelogs/xsurflog/embed'
      };
   }
};
</script>

<style scoped>
.text-dark-blue {
   color: #2c3e50;
}
.text-cyan {
   color: #00A0C1;
}
.btn-outline-cyan {
   color: #00A0C1;
   border-color: #00A0C1;
}
.btn-outline-cyan:hover {
   background-color: #00A0C1;
   color: #fff;
}
.iframe-container {
   min-height: 720px;
   background: #fff;
   border-radius: 12px;
}
.loading-overlay {
   position: absolute;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   background: rgba(255, 255, 255, 0.85);
   border-radius: 12px;
   z-index: 10;
}
</style>
